import script from "./register-index.vue?vue&type=script&setup=true&lang=js"
export * from "./register-index.vue?vue&type=script&setup=true&lang=js"

import "./register-index.vue?vue&type=style&index=0&id=7cb188f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb188f7"]])

export default __exports__